// extracted by mini-css-extract-plugin
module.exports = {"background":"CashbackTopBanner202501-module--background--2Hs0y"};